// extracted by mini-css-extract-plugin
export default {"primary":"#3aabf2","ratingStars":"rating-stars_ratingStars__nZFN3"};